<template>
    <div class="main">
        <div class="youtube-section">
            <h2 class="text-center">{{ $t('youtubeTitle') }}</h2>
            <div class="youtube-container">
                <iframe width="100%" height="315" :src="youtubeSrc" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            youtubeSrc: "https://www.youtube.com/embed/f9V_F-f2jW0"

        };
    }
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: 'Arial', sans-serif;
}

.main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    color: #EBE9CF;
    background: #edede8;
 
}


h1 {
    font-size: 3rem;
    font-weight: bold;
    color: #1E1E19;
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
    margin: 22px;
    line-height: 1.3;
}

.youtube-section {
    width: 100%;
    max-width: 1000px;
    margin-top: 40px;
    opacity: 0;
    animation: slideUp 1s ease-out forwards;
}

.youtube-section h2 {
    font-size: 2rem;
    font-weight: bold;
    color: #1E1E19;
    margin-bottom: 20px;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.youtube-container {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    border-radius: 12px;
    overflow: hidden;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    margin-bottom: 60px;
}

.youtube-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  
}



@keyframes slideUp {
    to {
        opacity: 1;
        transform: translateY(0);
    }

    from {
        opacity: 0;
        transform: translateY(50px);
    }
}

@media (max-width: 768px) {
    h1 {
        font-size: 2rem;
    }

    .youtube-section h2 {
        font-size: 1.6rem;
    }

    .frame {
        width: 100%;
        height: 60vh;
    }
}

@media (max-width: 480px) {
    h1 {
        font-size: 1.5rem;
    }

    .youtube-section h2 {
        font-size: 1.4rem;
    }

    .frame {
        height: 50vh;
    }
}

</style>